const Styles = {
    'OverlayHeader': 'OverlayHeader_OverlayHeader--63f80390'
};

export default Styles;